import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'app-toggle-tab',
	templateUrl: './toggle-tab.component.html',
	styleUrls: ['./toggle-tab.component.scss']
})
export class ToggleTabComponent {
	@Input() title = { title1: '', title2: '' };
	@Input() styleClass = '';
	showTab1 = true;
	@Output() changeTab = new EventEmitter<boolean>();

	clickTab(show: boolean): void {
		this.showTab1 = show;
		this.changeTab.emit(this.showTab1);
	}
}
